import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import lock from "../../Assets/Icon/lock.webp";
import {
  CreateEmployee,
  CreateEmployeeBulkUpload,
  GetDepartmentList,
  GetDesignationList,
  GetGenderType,
  GetUserType,
  SystemAdminEmployeeList,
  SystemadminAdminEmployeeActiveList,
  SystemadminDirectorEmployeeActiveList,
  SystemadminHodEmployeeActiveList,
  SystemadminIndenderEmployeeActiveList,
  SystemadminResetPassword,
  SystemadminStoreInchargeEmployeeActiveList,
  UpdateEmployee
} from "../../Repository/Api";
import {
  EmailValidation,
  NonEmptyValidation,
  PhoneNumberValidation,
  SelectValidation,
  StringValidation,
} from "../../Store/validate";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
const itemsPerPage = 10;

const SystemadminEmployeeList = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [employeeList, setEmployeeList] = useState({});
  const [hodEmployeeList, setHodEmployeeList] = useState({});
  const [adminEmployeeList, setAdminEmployeeList] = useState({});
  const [directorEmployeeList, setDirectorEmployeeList] = useState({});
  const [indendEmployeeList, setIndendEmployeeList] = useState({});
  const [storeInchargeEmployeeList, setStoreInchargeEmployeeList] = useState(
    {}
  );
  const [masterModel, setMasterModel] = useState(false);
  const [resetPasswordModel, setResetPasswordModel] = useState(false);
  const [validation, setValidation] = useState({});
  
  const [createEmployee, setCreateEmployee] = useState({});
  
  const [createResetPassword, setCreateResetPassword] = useState({});
  const [usertype, setUsertype] = useState([]);
  const [gendertype, setGendertype] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [departmentT, setDepartment] = useState([]);
  const [password, setPassword] = useState();
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkUpload, setBulkUpload] = useState({});
  const [active, setActive] = useState(0);
  const links = [
    "Staff",
    "Hod",
    "Admin",
    "Director",
    "Indender",
    "Store Incharge",
  ];
  const showSelected = (index) => {
    setActive(index);
  };
  const onChangeUpload = (e) => {
    setBulkUpload(e.target.files[0]);
  };
  const [activeEmployee, setActiveEmployee] = useState(0);
  const linksEmployee = ["Active", "Inactive", "Releaved"];
  const showSelectedEmployee = (index) => {
    setActiveEmployee(index);
  };
  const [activeHod, setActiveHod] = useState(0);
  const linksHod = ["Active", "Inactive"];
  const showSelectedHod = (index) => {
    setActiveHod(index);
  };
  const [activeIndend, setActiveIndend] = useState(0);
  const linksIndend = ["Active", "Inactive"];
  const showSelectedIndend = (index) => {
    setActiveIndend(index);
  };

  useEffect(() => {
    getEmployeeList();
    getHodEmployeeList();
    getAdminEmployeeList();
    getDirectorEmployeeList();
    getIndendEmployeeList();
    getStoreInchargeEmployeeList();
    getUserType();
    getGenderType();
    getDesignation();
    getDepartment();
  },[]);

  const [currentPage, setCurrentPage] = useState(1);
  const employeeListArray = Array.isArray(employeeList) ? employeeList : [];
  const employeeIndentListArray = Array.isArray(indendEmployeeList)
    ? indendEmployeeList
    : [];
  const employeeHodListArray = Array.isArray(hodEmployeeList)
    ? hodEmployeeList
    : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employeeListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentItemsHod = employeeHodListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentItemsIndent = employeeIndentListArray.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const activeLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "active").length
    : 0;
  const inactiveLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "inactive").length
    : 0;
  const releavedLength = Array.isArray(currentItems)
    ? currentItems.filter((item) => item.status === "releaved").length
    : 0;
  const activeHodLength = Array.isArray(currentItemsHod)
    ? currentItemsHod.filter((item) => item.status === "active").length
    : 0;
  const inactiveHodLength = Array.isArray(currentItemsHod)
    ? currentItemsHod.filter((item) => item.status === "inactive").length
    : 0;
  const activeIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "active").length
    : 0;
  const inactiveIndentLength = Array.isArray(currentItemsIndent)
    ? currentItemsIndent.filter((item) => item.status === "inactive").length
    : 0;

  const setData = (e, key) => {
    setCreateEmployee({ ...createEmployee, [key]: e });
    setCreateResetPassword({ ...createResetPassword, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const [dummyleaveList, setdummyLeaveList] = useState([]);

  const [searchText, setSearchText] = useState("");

  const SearchfilteredData = dummyleaveList?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchText) {
      setEmployeeList(SearchfilteredData);
      setCurrentPage(1)
    } else {
      setEmployeeList(dummyleaveList);
    }
  }, [searchText, dummyleaveList]);

  const getEmployeeList = async () => {
    const response = await SystemAdminEmployeeList(token);
    if (response && response.statusCode === 200) {
      // setEmployeeList(response?.data?.employee_details);
      setdummyLeaveList(response?.data?.employee_details);
    } else {
      errorMsg(response.message);
    }
  };
  //HOD
  const [dummyleaveListhod, setdummyLeaveListHod] = useState([]);

  const [searchTextHod, setSearchTextHod] = useState("");

  const SearchfilteredDataHod = dummyleaveListhod?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextHod.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextHod) {
      setHodEmployeeList(SearchfilteredDataHod);
      setCurrentPage(1)
    } else {
      setHodEmployeeList(dummyleaveListhod);
    }
  }, [searchTextHod, dummyleaveListhod]);

  const getHodEmployeeList = async () => {
    const response = await SystemadminHodEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setHodEmployeeList(response?.data?.employee_details);
      setdummyLeaveListHod(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };

  //Admin

  const [dummyleaveListAdmin, setdummyLeaveListAdmin] = useState([]);

  const [searchTextAdmin, setSearchTextAdmin] = useState("");

  const SearchfilteredDataAdmin = dummyleaveListAdmin?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextAdmin.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextAdmin) {
      setAdminEmployeeList(SearchfilteredDataAdmin);
      setCurrentPage(1)
    } else {
      setAdminEmployeeList(dummyleaveListAdmin);
      
    }
  }, [searchTextAdmin, dummyleaveListAdmin]);

  const getAdminEmployeeList = async () => {
    const response = await SystemadminAdminEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setAdminEmployeeList(response?.data?.employee_details);
      setdummyLeaveListAdmin(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  //director

  const [dummyleaveListDirector, setdummyLeaveListDirector] = useState([]);

  const [searchTextDirector, setSearchTextDirector] = useState("");

  const SearchfilteredDataDirector = dummyleaveListDirector?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextDirector.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextDirector) {
      setDirectorEmployeeList(SearchfilteredDataDirector);
      setCurrentPage(1)
    } else {
      setDirectorEmployeeList(dummyleaveListDirector);

    }
  }, [searchTextDirector, dummyleaveListDirector]);

  const getDirectorEmployeeList = async () => {
    const response = await SystemadminDirectorEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setDirectorEmployeeList(response?.data?.employee_details);
      setdummyLeaveListDirector(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  //Indend

  const [dummyleaveListIndend, setdummyLeaveListIndend] = useState([]);

  const [searchTextIndend, setSearchTextIndend] = useState("");

  const SearchfilteredDataIndend = dummyleaveListIndend?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextIndend.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextIndend) {
      setIndendEmployeeList(SearchfilteredDataIndend);
      setCurrentPage(1)
    } else {
      setIndendEmployeeList(dummyleaveListIndend);
    }
  }, [searchTextIndend, dummyleaveListIndend]);
  const getIndendEmployeeList = async () => {
    const response = await SystemadminIndenderEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setIndendEmployeeList(response?.data?.employee_details);
      
      setdummyLeaveListIndend(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  //store incharge

  const [dummyleaveListStoreIncharge, setdummyLeaveListStoreIncharge] = useState([]);

  const [searchTextStoreIncharge, setSearchTextStoreIncharge] = useState("");

  const SearchfilteredDataStoreIncharge = dummyleaveListStoreIncharge?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTextStoreIncharge.toLowerCase())
    )
  );

  useEffect(() => {
    if (searchTextStoreIncharge) {
      setStoreInchargeEmployeeList(SearchfilteredDataStoreIncharge);
      setCurrentPage(1)
    } else {
      setStoreInchargeEmployeeList(dummyleaveListStoreIncharge);
    }
  }, [searchTextStoreIncharge, dummyleaveListStoreIncharge]);
  const getStoreInchargeEmployeeList = async () => {
    const response = await SystemadminStoreInchargeEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      // setStoreInchargeEmployeeList(response?.data?.employee_details);
      setdummyLeaveListStoreIncharge(
        response?.data?.employee_details
      );
    } else {
      errorMsg(response.message);
    }
  };
  const getUserType = async () => {
    const response = await GetUserType(token);
    if (response && response.statusCode === 200) {
      setUsertype(response?.data?.master_data);
    } else {
      errorMsg(response.message);
    }
  };
  const getGenderType = async () => {
    const response = await GetGenderType(token);
    if (response && response.statusCode === 200) {
      setGendertype(response?.data?.master_data);
    } else {
      errorMsg(response.message);
    }
  };
  const getDesignation = async () => {
    const response = await GetDesignationList(token);
    if (response && response.statusCode === 200) {
      setDesignation(response?.data?.designation);
    } else {
      errorMsg(response.message);
    }
  };
  const getDepartment = async () => {
    const response = await GetDepartmentList(token);
    if (response && response.statusCode === 200) {
      setDepartment(response?.data?.department);
    } else {
      errorMsg(response.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.first_name = StringValidation(createEmployee?.first_name);
    validate.last_name = NonEmptyValidation(createEmployee?.last_name);
    validate.phone_number = PhoneNumberValidation(createEmployee?.phone_number);
    validate.user_type = NonEmptyValidation(createEmployee?.user_type);
    if (createEmployee?.user_type === "21995f27-0b39-4427-b96e-62c146938bf5") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.employee_id = NonEmptyValidation(createEmployee?.employee_id);
      validate.designation_id = NonEmptyValidation(
        createEmployee?.designation_id
      );
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
      validate.gender_id = NonEmptyValidation(createEmployee?.gender_id);
      validate.dob = NonEmptyValidation(createEmployee?.dob);
      validate.doj = NonEmptyValidation(createEmployee?.doj);
      validate.marital_status = SelectValidation(
        createEmployee?.marital_status
      );
      validate.probation_period = NonEmptyValidation(
        createEmployee?.probation_period
      );
      validate.pay_level = NonEmptyValidation(createEmployee?.pay_level);
      validate.differently_disabled = SelectValidation(
        createEmployee?.differently_disabled
      );
    }
    if (createEmployee?.user_type === "a8a4cd74-cc34-43db-9f7e-36c4bb506dac") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
      validate.hod_employee_id = NonEmptyValidation(
        createEmployee?.hod_employee_id
      );
    }
    if (createEmployee?.user_type === "7a644226-95c6-4b6f-8c5f-09d126db568e") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.admin_employee_id = NonEmptyValidation(
        createEmployee?.admin_employee_id
      );
    }
    if (
      createEmployee?.user_type === "0858e5cf-305b-4cb7-a5a4-418d9efc80d1" ||
      createEmployee?.user_type === "14fb3da2-0cf5-488c-84d2-99912a859235" ||
      createEmployee?.user_type === "23fec216-e3a9-4646-80f7-6fffdfd680cf" ||
      createEmployee?.user_type === "3f8bea9f-d8cd-4833-bb6c-12b395a0aa62"
    ) {
      validate.email_id = EmailValidation(createEmployee?.email_id);
    }
    if (
      createEmployee?.user_type === "7b145221-a1a2-4f83-aeb6-e0710ab1b04e" ||
      createEmployee?.user_type === "fa1c4a5e-19b7-4324-88df-fd6688264a91" ||
      createEmployee?.user_type === "c20ac342-9287-4c90-87c6-643aa72bb18a"
    ) {
      validate.employee_id = NonEmptyValidation(createEmployee?.employee_id);
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
    }

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...createEmployee,
      };
      const response = await CreateEmployee(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateEmployee({});
        setMasterModel(false);
        e.target.reset();
        getEmployeeList();
        getHodEmployeeList();
        getAdminEmployeeList();
        getDirectorEmployeeList();
        getIndendEmployeeList();
        getStoreInchargeEmployeeList();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.first_name = StringValidation(createEmployee?.first_name);
    validate.last_name = NonEmptyValidation(createEmployee?.last_name);
    validate.phone_number = PhoneNumberValidation(createEmployee?.phone_number);
    validate.user_type = NonEmptyValidation(createEmployee?.user_type);
    if (createEmployee?.user_type === "21995f27-0b39-4427-b96e-62c146938bf5") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.employee_id = NonEmptyValidation(createEmployee?.employee_id);
      validate.designation_id = NonEmptyValidation(
        createEmployee?.designation_id
      );
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
      validate.gender_id = NonEmptyValidation(createEmployee?.gender_id);
      validate.dob = NonEmptyValidation(createEmployee?.dob);
      validate.doj = NonEmptyValidation(createEmployee?.doj);
      validate.marital_status = SelectValidation(
        createEmployee?.marital_status
      );
      validate.probation_period = NonEmptyValidation(
        createEmployee?.probation_period
      );
      validate.pay_level = NonEmptyValidation(createEmployee?.pay_level);
      validate.differently_disabled = SelectValidation(
        createEmployee?.differently_disabled
      );
    }
    if (createEmployee?.user_type === "a8a4cd74-cc34-43db-9f7e-36c4bb506dac") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
      validate.hod_employee_id = NonEmptyValidation(
        createEmployee?.hod_employee_id
      );
    }
    if (createEmployee?.user_type === "7a644226-95c6-4b6f-8c5f-09d126db568e") {
      validate.email_id = EmailValidation(createEmployee?.email_id);
      validate.admin_employee_id = NonEmptyValidation(
        createEmployee?.admin_employee_id
      );
    }
    if (
      createEmployee?.user_type === "0858e5cf-305b-4cb7-a5a4-418d9efc80d1" ||
      createEmployee?.user_type === "14fb3da2-0cf5-488c-84d2-99912a859235" ||
      createEmployee?.user_type === "23fec216-e3a9-4646-80f7-6fffdfd680cf" ||
      createEmployee?.user_type === "3f8bea9f-d8cd-4833-bb6c-12b395a0aa62"
    ) {
      validate.email_id = EmailValidation(createEmployee?.email_id);
    }
    if (
      createEmployee?.user_type === "7b145221-a1a2-4f83-aeb6-e0710ab1b04e" ||
      createEmployee?.user_type === "fa1c4a5e-19b7-4324-88df-fd6688264a91" ||
      createEmployee?.user_type === "c20ac342-9287-4c90-87c6-643aa72bb18a"
    ) {
      validate.employee_id = NonEmptyValidation(createEmployee?.employee_id);
      validate.department_id = NonEmptyValidation(
        createEmployee?.department_id
      );
    }

    setValidation(validate);
    
    
    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...createEmployee,
      };
      delete Payload.user_type;
      delete Payload.hod_employee_name;
      delete Payload.admin_employee_name;
      delete Payload.user_type_value;
      delete Payload.department;
      delete Payload.designation;
      delete Payload.gender;
      delete Payload.is_deleted;
      delete Payload.officer_type;
      delete Payload.dor;
      const response = await UpdateEmployee(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateEmployee({});
        setMasterModel(false);
        e.target.reset();
        getEmployeeList();
        getHodEmployeeList();
        getAdminEmployeeList();
        getDirectorEmployeeList();
        getIndendEmployeeList();
        getStoreInchargeEmployeeList();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    const Payload = {
      id: createResetPassword.id,
      password: createResetPassword.password,
    };
    const response = await SystemadminResetPassword(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setCreateResetPassword({});
      setResetPasswordModel(false);
      e.target.reset();
      getEmployeeList();
      getHodEmployeeList();
      getAdminEmployeeList();
      getDirectorEmployeeList();
      getIndendEmployeeList();
      getStoreInchargeEmployeeList();
    } else {
      errorMsg(response.message);
    }
  };
  const viewPassword = () => {
    setPassword(!password);
  };
  const UploadDocument = async (e, key) => {
    let formData = new FormData();
    formData.append("file", bulkUpload);
    formData.append(
      "fileName",
      moment().format("YYYYMMDDHHmmss") + "_" + bulkUpload
    );
    formData.append("file_path", "/reference_document");
    const response = await CreateEmployeeBulkUpload(formData, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setBulkModal(false);
      getEmployeeList();
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row justify-content-between">
              <div className="col-lg-10">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
              <div className="col-lg-2">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => setMasterModel(true)}
                  >
                    Add Employee
                  </button>
                </div>
              </div>

            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-2">
                    <h6 className="labeltitle">Employee List</h6>
                  </div>
                  <div className="col-lg-8">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="scroll-table">
                  {active === 0 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <ul className="searchtopflex">
                          {linksEmployee.map((linkEmp, index) => {
                            return (
                              <li
                                onClick={() => showSelectedEmployee(index)}
                                key={linkEmp}
                                className={
                                  activeEmployee === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linkEmp}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeEmployee === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                              <th scope="col">Reset Password</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink textformat"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                    <td
                                      className="resetbuttonoption"
                                      onClick={() => {
                                        setResetPasswordModel(true);
                                        setCreateResetPassword(employee);
                                      }}
                                    >
                                      <span className="material-symbols-outlined">
                                        lock_reset
                                      </span>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td colSpan="4">
                                <nav aria-label="...">
                                  <ul className="pagination">
                                    <li
                                      className={`page-item ${currentPage === 1 ? "disabled" : ""
                                        }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          paginate(currentPage - 1)
                                        }
                                      >
                                        Previous
                                      </button>
                                    </li>
                                    {Array.from({
                                      length: Math.ceil(
                                        employeeList.length / itemsPerPage
                                      ),
                                    }).map((_, index) => (
                                      <li
                                        key={index}
                                        className={`page-item ${currentPage === index + 1
                                          ? "active"
                                          : ""
                                          }`}
                                      >
                                        <button
                                          className="page-link"
                                          onClick={() => paginate(index + 1)}
                                        >
                                          {index + 1}
                                        </button>
                                      </li>
                                    ))}
                                    <li
                                      className={`page-item ${currentPage ===
                                        Math.ceil(
                                          employeeList.length / itemsPerPage
                                        )
                                        ? "disabled"
                                        : ""
                                        }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          paginate(currentPage + 1)
                                        }
                                      >
                                        Next
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      )}
                      {activeEmployee === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      {activeEmployee === 2 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Designation</th>
                              <th scope="col">Department</th>
                              <th scope="col">Employee ID</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {releavedLength > 0 ? (
                              currentItems &&
                              currentItems
                                ?.filter((item) => item.status === "releaved")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.designation
                                        ? employee?.designation
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>

                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 1 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextHod}
                              onChange={(e) => setSearchTextHod(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <ul className="searchtopflex">
                          {linksHod.map((linksHo, index) => {
                            return (
                              <li
                                onClick={() => showSelectedHod(index)}
                                key={linksHo}
                                className={
                                  activeHod === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linksHo}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeHod === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                              <th scope="col">Reset Password</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeHodLength > 0 ? (
                              currentItemsHod &&
                              currentItemsHod
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink textformat"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td className="textformat">
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                    <td
                                      className="resetbuttonoption"
                                      onClick={() => {
                                        setResetPasswordModel(true);
                                        setCreateResetPassword(employee);
                                      }}
                                    >
                                      <span className="material-symbols-outlined">
                                        lock_reset
                                      </span>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    hodEmployeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeHod === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveHodLength > 0 ? (
                              currentItemsHod &&
                              currentItemsHod
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 2 && (
                    <>
                      {" "}
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextAdmin}
                              onChange={(e) =>
                                setSearchTextAdmin(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                            <th scope="col">Reset Password</th>
                          </tr>
                        </thead>
                        <tbody>
                          {adminEmployeeList?.length > 0 ? (
                            adminEmployeeList &&
                            adminEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td
                                  className="namelink"
                                  onClick={() => {
                                    setMasterModel(true);
                                    setCreateEmployee(employee);
                                  }}
                                >
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                  &nbsp;
                                  {employee?.last_name
                                    ? employee?.last_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id
                                    ? employee?.email_id
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                                <td
                                  className="resetbuttonoption"
                                  onClick={() => {
                                    setResetPasswordModel(true);
                                    setCreateResetPassword(employee);
                                  }}
                                >
                                  <span className="material-symbols-outlined">
                                    lock_reset
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 3 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextDirector}
                              onChange={(e) =>
                                setSearchTextDirector(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                            <th scope="col">Reset Password</th>
                          </tr>
                        </thead>
                        <tbody>
                          {directorEmployeeList?.length > 0 ? (
                            directorEmployeeList &&
                            directorEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td
                                  className="namelink"
                                  onClick={() => {
                                    setMasterModel(true);
                                    setCreateEmployee(employee);
                                  }}
                                >
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                  &nbsp;
                                  {employee?.last_name
                                    ? employee?.last_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id
                                    ? employee?.email_id
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                                <td
                                  className="resetbuttonoption"
                                  onClick={() => {
                                    setResetPasswordModel(true);
                                    setCreateResetPassword(employee);
                                  }}
                                >
                                  <span className="material-symbols-outlined">
                                    lock_reset
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </>
                  )}
                  {active === 4 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextIndend}
                              onChange={(e) =>
                                setSearchTextIndend(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <ul className="searchtopflex">
                          {linksIndend.map((linksInd, index) => {
                            return (
                              <li
                                onClick={() => showSelectedIndend(index)}
                                key={linksInd}
                                className={
                                  activeIndend === index
                                    ? "agenttextactive"
                                    : "agenttextinactive"
                                }
                              >
                                {linksInd}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {activeIndend === 0 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Indent ID</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                              <th scope="col">Reset Password</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "active")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                      &nbsp;
                                      {employee?.last_name
                                        ? employee?.last_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.employee_id
                                        ? employee?.employee_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                    <td
                                      className="resetbuttonoption"
                                      onClick={() => {
                                        setResetPasswordModel(true);
                                        setCreateResetPassword(employee);
                                      }}
                                    >
                                      <span className="material-symbols-outlined">
                                        lock_reset
                                      </span>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <td></td>
                            <td colSpan="4">
                              <div className="mt-5">
                                {Array.from({
                                  length: Math.ceil(
                                    indendEmployeeList.length / itemsPerPage
                                  ),
                                }).map((page, index) => (
                                  <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className="paginationbutton"
                                  >
                                    {index + 1}
                                  </button>
                                ))}
                              </div>
                            </td>
                          </tfoot>
                        </table>
                      )}
                      {activeIndend === 1 && (
                        <table className="table table-hover mt-5">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email Id</th>
                              <th scope="col">Phone No</th>
                              <th scope="col">More Info</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inactiveIndentLength > 0 ? (
                              currentItemsIndent &&
                              currentItemsIndent
                                ?.filter((item) => item.status === "inactive")
                                ?.map((employee, index) => (
                                  <tr key={index}>
                                    <td
                                      className="namelink"
                                      onClick={() => {
                                        setMasterModel(true);
                                        setCreateEmployee(employee);
                                      }}
                                    >
                                      {employee?.first_name
                                        ? employee?.first_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.department
                                        ? employee?.department
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.email_id
                                        ? employee?.email_id
                                        : "-"}
                                    </td>
                                    <td>
                                      {employee?.phone_number
                                        ? employee?.phone_number
                                        : "-"}
                                    </td>
                                    <td className="viewoption">
                                      <Link
                                        to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                      >
                                        View Details
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div> No Data Found</div>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}
                  {active === 5 && (
                    <>
                      <div className="row justify-content-end mt-3">
                        <div className="col-lg-4">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping">
                              <span class="material-symbols-outlined search-input-icon">
                                search
                              </span>
                            </span>
                            <input
                              type="text"
                              class="form-control search-table-data"
                              placeholder="Search"
                              aria-describedby="addon-wrapping"
                              name="search"
                              value={searchTextStoreIncharge}
                              onChange={(e) =>
                                setSearchTextStoreIncharge(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email Id</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">More Info</th>
                            <th scope="col">Reset Password</th>
                          </tr>
                        </thead>
                        <tbody>
                          {storeInchargeEmployeeList?.length > 0 ? (
                            storeInchargeEmployeeList &&
                            storeInchargeEmployeeList?.map((employee, index) => (
                              <tr key={index}>
                                <td
                                  className="namelink"
                                  onClick={() => {
                                    setMasterModel(true);
                                    setCreateEmployee(employee);
                                  }}
                                >
                                  {employee?.first_name
                                    ? employee?.first_name
                                    : "-"}
                                  &nbsp;
                                  {employee?.last_name
                                    ? employee?.last_name
                                    : "-"}
                                </td>
                                <td>
                                  {employee?.email_id ? employee?.email_id : "-"}
                                </td>
                                <td>
                                  {employee?.phone_number
                                    ? employee?.phone_number
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Systemadmin/SystemadminEmployeeSpecificView/${employee?.id}`}
                                  >
                                    View Details
                                  </Link>
                                </td>
                                <td
                                  className="resetbuttonoption"
                                  onClick={() => {
                                    setResetPasswordModel(true);
                                    setCreateResetPassword(employee);
                                  }}
                                >
                                  <span className="material-symbols-outlined">
                                    lock_reset
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table></>

                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* masterModel */}
        <CustomModal
          open={masterModel}
          onClickOutside={() => {
            setMasterModel(false);
            setCreateEmployee({});
          }}
        >
          <form
            onSubmit={(e) => {
              if (createEmployee.id) {
                handleUpdate(e);
              } else {
                handleSubmit(e);
              }
            }}
          >
            <div className="modal-content  m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">
                  {createEmployee.id ? "Update" : "Add New"}
                  &nbsp;Employee
                </h5>
              </div>
              <div className="modal-body p-0">
                <div className="container">
                  <div className="employeescrollheight">
                    <div className="row mt-2">
                      <div className="col-lg-4">
                        <label className="labeltext">First Name *</label>
                        <div>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter First Name"
                            defaultValue={createEmployee?.first_name}
                            onChange={(e) => {
                              setData(e.target.value, "first_name");
                            }}
                          />
                        </div>
                        <small className="validationerror">
                          {validation?.first_name?.message
                            ? `First Name ${validation?.first_name?.message}`
                            : ""}
                        </small>
                      </div>
                      <div className="col-lg-4">
                        <label className="labeltext">Last Name *</label>
                        <div>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Last Name"
                            defaultValue={createEmployee?.last_name}
                            onChange={(e) => {
                              setData(e.target.value, "last_name");
                            }}
                          />
                        </div>
                        <small className="validationerror">
                          {validation?.last_name?.message
                            ? `Last Name ${validation?.last_name?.message}`
                            : ""}
                        </small>
                      </div>
                      {createEmployee.id ? (
                        <div className="col-lg-4">
                          <label className="labeltext"> User Type *</label>
                          <div>
                            <select
                              className="fieldinput"
                              defaultValue={createEmployee?.user_type}
                              onChange={(e) => {
                                setData(e.target.value, "user_type");
                              }}
                              disabled
                            >
                              <option value="">Select User Type</option>
                              {usertype?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.master_value}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      ) : (
                        <div className="col-lg-4">
                          <label className="labeltext"> User Type *</label>
                          <div>
                            <select
                              className="fieldinput"
                              defaultValue={createEmployee?.user_type}
                              onChange={(e) => {
                                setData(e.target.value, "user_type");
                              }}
                            >
                              <option value="">Select User Type</option>
                              {usertype?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.master_value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <small className="validationerror">
                            {validation?.user_type?.message
                              ? `User Type ${validation?.user_type?.message}`
                              : ""}
                          </small>
                        </div>
                      )}
                      <div className="col-lg-4">
                        <label className="labeltext">Phone Number *</label>
                        <div>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Phone Number"
                            maxLength={10}
                            defaultValue={createEmployee?.phone_number}
                            onChange={(e) => {
                              setData(e.target.value, "phone_number");
                            }}
                          />
                        </div>
                        <small className="validationerror">
                          {validation?.phone_number?.message
                            ? `Phone Number ${validation?.phone_number?.message}`
                            : ""}
                        </small>
                      </div>
                      {createEmployee?.user_type ===
                        "21995f27-0b39-4427-b96e-62c146938bf5" ? (
                        <>
                          <div className="col-lg-4">
                            <label className="labeltext">Email Id *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinputemail"
                                placeholder="Enter Email Id"
                                defaultValue={createEmployee?.email_id}
                                onChange={(e) => {
                                  setData(e.target.value, "email_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.email_id?.message
                                ? `Email ID ${validation?.email_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Employee ID *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinput"
                                placeholder="Enter Employee ID"
                                defaultValue={createEmployee?.employee_id}
                                onChange={(e) => {
                                  setData(e.target.value, "employee_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.employee_id?.message
                                ? `Employee ID ${validation?.employee_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Designation *</label>
                            <div>
                              <select
                                className="fieldinput"
                                defaultValue={createEmployee?.designation_id}
                                onChange={(e) => {
                                  setData(e.target.value, "designation_id");
                                }}
                              >
                                <option value="">Select Designation</option>
                                {designation?.map((e, index) => (
                                  <option key={index} value={e.id}>
                                    {e.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <small className="validationerror">
                              {validation?.designation_id?.message
                                ? `Designation ${validation?.designation_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Department *</label>
                            <div>
                              <select
                                className="fieldinput"
                                defaultValue={createEmployee?.department_id}
                                onChange={(e) => {
                                  setData(e.target.value, "department_id");
                                }}
                              >
                                <option value="">Select Department</option>
                                {departmentT?.map((e, index) => (
                                  <option key={index} value={e.id}>
                                    {e.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <small className="validationerror">
                              {validation?.department_id?.message
                                ? `Department ${validation?.department_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext"> Gender *</label>
                            <div>
                              <select
                                className="fieldinput"
                                defaultValue={createEmployee?.gender_id}
                                onChange={(e) => {
                                  setData(e.target.value, "gender_id");
                                }}
                              >
                                <option value="">Select Gender Type</option>
                                {gendertype?.map((e, index) => (
                                  <option key={index} value={e.id}>
                                    {e.master_value}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <small className="validationerror">
                              {validation?.gender_id?.message
                                ? `Gender ${validation?.gender_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Father's Name *</label>
                            <input
                              type="text"
                              className="fieldinput"
                              placeholder="Enter Father's Name"
                              defaultValue={createEmployee?.father_name}
                              onChange={(e) => {
                                setData(e.target.value, "father_name");
                              }}
                            />
                          </div>
                          {createEmployee.id ? (
                            <div className="col-lg-4">
                              <label className="labeltext">
                                Date of Birth: *
                              </label>
                              <div>
                                <input
                                  type="date"
                                  className="fieldinput"
                                  placeholder=""
                                  defaultValue={moment(
                                    createEmployee?.dob
                                  ).format("yyyy-MM-DD")}
                                  onChange={(e) => {
                                    setData(e.target.value, "dob");
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.dob?.message
                                  ? `DOB ${validation?.dob?.message}`
                                  : ""}
                              </small>
                            </div>
                          ) : (
                            <div className="col-lg-4">
                              <label className="labeltext">
                                Date of Birth: *
                              </label>
                              <div>
                                <input
                                  type="date"
                                  className="fieldinput"
                                  placeholder=""
                                  value={createEmployee?.dob}
                                  onChange={(e) => {
                                    setData(e.target.value, "dob");
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.dob?.message
                                  ? `DOB ${validation?.dob?.message}`
                                  : ""}
                              </small>
                            </div>
                          )}
                          {createEmployee.id ? (
                            <div className="col-lg-4">
                              <label className="labeltext">
                                Date of Joining: *
                              </label>
                              <div>
                                <input
                                  type="date"
                                  className="fieldinput"
                                  placeholder=""
                                  defaultValue={moment(
                                    createEmployee?.doj
                                  ).format("yyyy-MM-DD")}
                                  onChange={(e) => {
                                    setData(e.target.value, "doj");
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.doj?.message
                                  ? `DOJ ${validation?.doj?.message}`
                                  : ""}
                              </small>
                            </div>
                          ) : (
                            <div className="col-lg-4">
                              <label className="labeltext">
                                Date of Joining: *
                              </label>
                              <div>
                                <input
                                  type="date"
                                  className="fieldinput"
                                  placeholder=""
                                  value={createEmployee?.doj}
                                  onChange={(e) => {
                                    setData(e.target.value, "doj");
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.doj?.message
                                  ? `DOJ ${validation?.doj?.message}`
                                  : ""}
                              </small>
                            </div>
                          )}
                          <div className="col-lg-4">
                            <label className="labeltext">Marital Status: *</label>
                            <div>
                              <select
                                className="fieldinput"
                                defaultValue={createEmployee?.marital_status}
                                onChange={(e) => {
                                  setData(e.target.value, "marital_status");
                                }}
                              >
                                <option value="">Select Marital Status</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                            <small className="validationerror">
                              {validation?.marital_status?.message
                                ? `Marital Status ${validation?.marital_status?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">
                              Probation Period *
                            </label>
                            <div>
                              <input
                                type="text"
                                className="fieldinput"
                                placeholder="Enter Probation Period"
                                defaultValue={createEmployee?.probation_period}
                                onChange={(e) => {
                                  setData(e.target.value, "probation_period");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.probation_period?.message
                                ? `Probation Period ${validation?.probation_period?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Pay Level *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinput"
                                placeholder="Enter Pay Level"
                                defaultValue={createEmployee?.pay_level}
                                onChange={(e) => {
                                  setData(e.target.value, "pay_level");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.pay_level?.message
                                ? `Pay Level ${validation?.pay_level?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">
                              Differently Disabled *
                            </label>
                            <div>
                              <select
                                className="fieldinput"
                                defaultValue={
                                  createEmployee?.differently_disabled
                                }
                                onChange={(e) => {
                                  setData(
                                    e.target.value,
                                    "differently_disabled"
                                  );
                                }}
                              >
                                <option value="">
                                  Select Differently Disabled
                                </option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                            <small className="validationerror">
                              {validation?.differently_disabled?.message
                                ? `Disabled Status ${validation?.differently_disabled?.message}`
                                : ""}
                            </small>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {createEmployee?.user_type ===
                        "a8a4cd74-cc34-43db-9f7e-36c4bb506dac" ? (
                        <>
                          <div className="col-lg-4">
                            <label className="labeltext">Email Id *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinputemail"
                                placeholder="Enter Email Id"
                                defaultValue={createEmployee?.email_id}
                                onChange={(e) => {
                                  setData(e.target.value, "email_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.email_id?.message
                                ? `Email ID ${validation?.email_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Department *</label>
                            <select
                              className="fieldinput"
                              defaultValue={createEmployee?.department_id}
                              onChange={(e) => {
                                setData(e.target.value, "department_id");
                              }}
                            >
                              <option value="">Select Department</option>
                              {departmentT?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                            <small className="validationerror">
                              {validation?.department_id?.message
                                ? `Department ${validation?.department_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Employee *</label>
                            <select
                              className="fieldinput"
                              value={createEmployee?.hod_employee_id}
                              onChange={(e) => {
                                setData(e.target.value, "hod_employee_id");
                              }}
                            >
                              <option value="">Select Employee</option>
                              {employeeList &&
                                employeeList?.map((e, index) => (
                                  <option key={index} value={e.id}>
                                    {e.first_name}
                                  </option>
                                ))}
                            </select>
                            <small className="validationerror">
                              {validation?.hod_employee_id?.message
                                ? `Employee ${validation?.hod_employee_id?.message}`
                                : ""}
                            </small>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {createEmployee?.user_type ===
                        "7a644226-95c6-4b6f-8c5f-09d126db568e" ? (
                        <>
                          <div className="col-lg-4">
                            <label className="labeltext">Email Id *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinputemail"
                                placeholder="Enter Email Id"
                                defaultValue={createEmployee?.email_id}
                                onChange={(e) => {
                                  setData(e.target.value, "email_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.email_id?.message
                                ? `Email ID ${validation?.email_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Employee *</label>
                            <select
                              className="fieldinput"
                              value={createEmployee?.admin_employee_id}
                              onChange={(e) => {
                                setData(e.target.value, "admin_employee_id");
                              }}
                            >
                              <option value="">Select Employee</option>
                              {employeeList &&
                                employeeList?.map((e, index) => (
                                  <option key={index} value={e.id}>
                                    {e.first_name}
                                  </option>
                                ))}
                            </select>
                            <small className="validationerror">
                              {validation?.admin_employee_id?.message
                                ? `Employee ${validation?.admin_employee_id?.message}`
                                : ""}
                            </small>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {createEmployee?.user_type ===
                        "0858e5cf-305b-4cb7-a5a4-418d9efc80d1" ||
                        createEmployee?.user_type ===
                        "3f8bea9f-d8cd-4833-bb6c-12b395a0aa62" ||
                        createEmployee?.user_type ===
                        "14fb3da2-0cf5-488c-84d2-99912a859235" ||
                        createEmployee?.user_type ===
                        "23fec216-e3a9-4646-80f7-6fffdfd680cf" ? (
                        <>
                          <div className="col-lg-4">
                            <label className="labeltext">Email Id *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinputemail"
                                placeholder="Enter Email Id"
                                defaultValue={createEmployee?.email_id}
                                onChange={(e) => {
                                  setData(e.target.value, "email_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.email_id?.message
                                ? `Email ID ${validation?.email_id?.message}`
                                : ""}
                            </small>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {createEmployee?.user_type ===
                        "7b145221-a1a2-4f83-aeb6-e0710ab1b04e" ||
                        createEmployee?.user_type ===
                        "fa1c4a5e-19b7-4324-88df-fd6688264a91" ||
                        createEmployee?.user_type ===
                        "c20ac342-9287-4c90-87c6-643aa72bb18a" ? (
                        <>
                          <div className="col-lg-4">
                            <label className="labeltext">Indent ID *</label>
                            <div>
                              <input
                                type="text"
                                className="fieldinput"
                                placeholder="Enter Indent ID"
                                defaultValue={createEmployee?.employee_id}
                                onChange={(e) => {
                                  setData(e.target.value, "employee_id");
                                }}
                              />
                            </div>
                            <small className="validationerror">
                              {validation?.employee_id?.message
                                ? `Indent ID ${validation?.employee_id?.message}`
                                : ""}
                            </small>
                          </div>
                          <div className="col-lg-4">
                            <label className="labeltext">Department *</label>
                            <select
                              className="fieldinput"
                              defaultValue={createEmployee?.department_id}
                              onChange={(e) => {
                                setData(e.target.value, "department_id");
                              }}
                            >
                              <option value="">Select Department</option>
                              {departmentT?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                            <small className="validationerror">
                              {validation?.department_id?.message
                                ? `Department ${validation?.department_id?.message}`
                                : ""}
                            </small>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {createEmployee.id ? (
                        <>
                          {createEmployee?.user_type ===
                            "21995f27-0b39-4427-b96e-62c146938bf5" ? (
                            <div className="col-lg-4">
                              <label className="labeltext"> Status *</label>
                              <div>
                                <select
                                  className="fieldinput"
                                  defaultValue={createEmployee?.status}
                                  onChange={(e) => {
                                    setData(e.target.value, "status");
                                  }}
                                >
                                  <option value="">Select User Type</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">InActive</option>
                                  <option value="releaved">Releaved</option>
                                </select>
                              </div>
                            </div>
                          ) : (
                            <div className="col-lg-4">
                              <label className="labeltext"> Status *</label>
                              <div>
                                <select
                                  className="fieldinput"
                                  defaultValue={createEmployee?.status}
                                  onChange={(e) => {
                                    setData(e.target.value, "status");
                                  }}
                                >
                                  <option value="">Select User Type</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">InActive</option>
                                </select>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setMasterModel(false);
                      setValidation({});
                      setCreateEmployee({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 submit-btn">
                    {createEmployee.id ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>

        {/* Reset Password Model */}
        <CustomModal
          open={resetPasswordModel}
          onClickOutside={() => {
            setResetPasswordModel(false);
            setCreateEmployee({});
          }}
        >
          <form
            onSubmit={(e) => {
              handleUpdatePassword(e);
            }}
          >
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Reset Password</h5>
              </div>
              <div className="modal-body p-0">
                <div className="container">
                  <div className="row mt-2">
                    <div className="col-lg-8 mx-auto ms-auto">
                      <div className="inputspace">
                        <label className="labeltext mb-3">Reset Password</label>
                        <img className="icon" src={lock} alt="User" />
                        <input
                          type={password ? "text" : "password"}
                          className="input-fieldreset"
                          placeholder="PASSWORD"
                          defaultValue={createResetPassword.password}
                          onChange={(e) => {
                            setData(e.target.value, "password");
                          }}
                        />
                        <div className="psw-iconreset">
                          {password ? (
                            <span
                              className="material-symbols-rounded align-middle"
                              onClick={() => viewPassword()}
                            >
                              visibility
                            </span>
                          ) : (
                            <span
                              className="material-symbols-rounded  align-middle"
                              onClick={() => viewPassword()}
                            >
                              visibility_off
                            </span>
                          )}
                        </div>
                        {validation.password && (
                          <p className="validationmsg">{validation.password}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setResetPasswordModel(false);
                      setValidation({});
                      setCreateResetPassword({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 submit-btn">
                    Reset Password
                  </button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>

        {/* Bulk upload Modal */}
        <CustomModal
          open={bulkModal}
          onClickOutside={() => {
            setBulkModal(false);
          }}
        >
          <div className="modal-content Modal-View m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">Bulk Upload</h5>
            </div>
            <div className="modal-body p-0">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-12">
                        <div className=" my-5 px-3">
                          <div className="row justify-content-center mt-2">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Upload Report:
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  id="myfile"
                                  accept=".xls,.xlsx"
                                  name="file"
                                  onChange={onChangeUpload}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setBulkModal(false);
                      setBulkUpload({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button
                    className="btn mx-2 submit-btn"
                    onClick={UploadDocument}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        </CustomModal>
      </div>
    </>
  );
};

export default SystemadminEmployeeList;
